export enum shippingCopy {
  LEGAL_TEXT_FOR_USER_MATCH_APPROVAL = "I have reviewed the item described above and agree that the item matches my claim.",
  SHIPPING_TAGLINE = "Shipping is easy - we'll just need to collect your address and payment info.",
  SHIP_MY_ITEM_BUTTON = "Ship my item!",
  PICK_IT_UP_BUTTON = "Pick it up!",
  PICK_IT_UP_DESCRIPTION = "Don't want it shipped?",
  PICK_UP_TAGLINE = "Feel free to stop by the front desk at anytime to pick up your item!",
}
